import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../common/icons/Icon';
import Loading from '../../../common/components/Loading';

class ProfileFieldBase extends Component {
  static propTypes = {
    formatDisplayData: PropTypes.func,
    inputTag: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
    inputTagAttributes: PropTypes.object,
    inputTagChildren: PropTypes.node,
    placeHolder: PropTypes.string,
    validateMethod: PropTypes.func,
    validations: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  };

  displayData = data => {
    if (this.props.formatDisplayData) {
      return this.props.formatDisplayData(data);
    }
    return data;
  };

  state = {
    isEditing: false,
    isSaving: false,
    editData: null,
    errors: [],
  };

  componentWillReceiveProps = nextProps => {
    const { fieldData } = this.props;

    if (nextProps.fieldData !== fieldData) {
      this.setState({
        isSaving: false,
        isEditing: false,
        editData: null,
      });
    }
  };

  handleSubmit = e => {
    const { action, validateMethod, validations } = this.props;
    const { editData } = this.state;
    e.preventDefault();
    let errors = [];

    if (validateMethod && validations) {
      errors = validateMethod(validations, editData);
    } else if (validateMethod) {
      errors = validateMethod(editData);
    }

    if (errors.length === 0) {
      this.setState({ isSaving: true }, () => {
        action(editData);
      });
    } else {
      this.setState({ errors: errors });
    }
  };

  handleChange = e => {
    const value = e.target.value;
    this.setState({ editData: value });
  };

  toggleEdit = () => {
    const { isEditing } = this.state;
    const { fieldData } = this.props;
    let stateUpdate = { isEditing: !isEditing };
    if (isEditing) {
      stateUpdate.editData = null;
    } else {
      stateUpdate.editData = fieldData || '';
    }
    this.setState(stateUpdate);
  };

  renderNotEditing = () => {
    const { editable, placeHolder } = this.props;

    return (
      <div className="profile-base-field">
        <div className="profile-text-field">
          <span>{this.displayData(this.props.fieldData) || placeHolder}</span>
          {editable && (
            <button className="profile-text-field__edit-button" type="button" onClick={this.toggleEdit}>
              <Icon icon="Pencil" />
            </button>
          )}
        </div>
      </div>
    );
  };

  renderEditing = () => {
    const { editData, errors } = this.state;
    const { fieldData, inputTag, inputTagAttributes, isSelect } = this.props;
    const displayData = isSelect ? editData || '' : this.displayData(editData) || '';
    const canSave = this.displayData(fieldData) !== this.displayData(editData);

    return (
      <div className="profile-base-field">
        <div className="profile-text-field editing">
          <form onSubmit={this.handleSubmit}>
            <div className="input-scaffold">
              {React.createElement(
                inputTag,
                {
                  value: displayData,
                  onChange: this.handleChange,
                  ...inputTagAttributes,
                },
                this.props.inputTagChildren
              )}
            </div>
            <div className="actions--wrapper">
              <div className="actions--wrapper__buttons">
                <button className="button button--theme--plain button--small" type="button" onClick={this.toggleEdit}>
                  Cancel
                </button>
                <button className="button button--small" type="submit" disabled={!canSave}>
                  Save
                </button>
              </div>

            </div>
          </form>
        </div>
        {errors.length > 0 ? (
          <div className="profile-error__wrapper">
            {errors.map((error, index) => {
              return (
                <div className="profile-error--error" key={`error-${index}`}>
                  {error}
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  };

  render = () => {
    const { isEditing, isSaving } = this.state;

    if (isSaving) return <Loading />;

    return isEditing ? this.renderEditing() : this.renderNotEditing();
  };
}

export default ProfileFieldBase;



// WEBPACK FOOTER //
// ./src/subscription/profile/components/ProfileFieldBase.js